<template>
  <div class="box15">
    <div class="title">Java架构师经典微课</div>

    <div class="content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="block" @click="toLink(item.href,item.title)">
            <img
              :src="item.img"
              alt
            />
            <div class="tit">{{ item.title }}</div>
            <div class="text" v-html="item.text"></div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      swiperOption: {
        // loop: true, // 循环模式选项
        slidesPerView: "auto",

        pagination: {
          el: ".swiper-pagination-box14",
        },
      },
      list: [
        // {
        //   title: "50小时搞定企业级核心框架",
        //   text: " 以具体技能点为需求的职场提升课<br />侧重于企业级框架搭建和定制<br /> 聚焦于架构师在项目开发层基础框架部分<br />Java工程师进阶必学的核心内容",
        //   img: require("../../../assets/coursePage/architect/box14/01.jpg"),
        //   href: "https://m.boxuegu.com/course/detail-5641",
        // },
        {
          title: "RPC-分布式通信利器",
          text: "聚焦框架的使用和架构设计<br />流程清晰、易于吸收<br />学完具备独立设计RPC框架的能力<br />架构师必学核心技术",
          href: "https://m.boxuegu.com/course/detail-5536",
          img: require("../../../assets/coursePage/architect/box14/02.png"),
        },
        {
          title: "Redis6从入门进阶到实战面试",
          text: "对Redis的使用停留在基本数据类型上？<br />缺乏Redis大规模集群场景下的经验、<br/>底层架构原理的认知、高级功能的灵活运用？本课程助你补齐短板",
          href: "https://m.boxuegu.com/course/detail-4960",
          img: require("../../../assets/coursePage/architect/box14/03.png"),
        },
      ],
    };
  },
  methods: {
    toLink(href,name) {
       this.mai("狂野架构师-职场进阶课",name,1,null)
      window.open(href);
    },
  },
};
</script>

<style lang="less" scoped>
.box15 {
  padding: 80px 0px 88px;
  width: 100%;
  background: #e5f0ff;

  .title {
    margin-bottom: 48px;
    font-family: PingFangSC-Semibold;
    font-size: 40px;
    text-align: center;
    font-weight: bold;
  }

  .swiper-slide {
    width: 478px;
    margin-left: 32px;
    flex-shrink: 0;
  }
  .swiper-slide:nth-child(3) {
    margin-right: 32px;
  }
  .seat {
    width: 32px;
    flex-shrink: 0;
  }
  .content {
    position: relative;
  }

  .block {
    width: 478px;
    height: 542px;
    background: #ffffff;
    border-radius: 20px;
    padding: 20px 0 20px 20px;
    box-sizing: border-box;

    img {
      width: 438px;
      height: 262px;
      background: #dcdcdc;
      border-radius: 20px;
    }

    .tit {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1d2129;
      line-height: 44px;
      margin: 24px 0 8px;
      margin-left: 8px;
    }

    .text {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 40px;
      margin-left: 8px;
    }
  }

  .swiper-pagination-box14 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    width: 40px;
    height: 6px;

    // background: #70c3f7;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    // margin: 0px 4px;
    width: 20px;
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
    opacity: 1;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background-color: #57a3f5;
    border-radius: 3px;
  }
}
</style>
